export const d = 'm274-450 248 248-42 42-320-320 320-320 42 42-248 248h526v60H274Z';

export default d;
